import $ from 'jquery';

import { LeadPopupCtrl } from '../lead.popup/lead.popup.controller';
import leadPopupTemplate from '../lead.popup/lead.popup.html';
import { UnitPopupCtrl } from '../unit.popup/UnitPopupCtrl';
import unitPopupTemplate from '../unit.popup/unit.popup.html';
import template from './appeals.html';
import { AppealsController } from './AppealsController';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  if (
    document.location.pathname === '/appeals' &&
    (!document.location.hash || document.location.hash === '#/')
  ) {
    document.location.hash = 'appeals';
  }

  $stateProvider
    .state('appeals', {
      url: '/appeals',
      controller: AppealsController,
      controllerAs: 'vm',
      template,
    })
    .state('appeals.unitpopup', {
      url: '/unit/:id',
      views: {
        drawer: {
          controller: UnitPopupCtrl,
          controllerAs: 'vm',
          template: unitPopupTemplate,
        },
      },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    })
    .state('appeals.leadpopup', {
      url: '/lead/:id',
      views: {
        drawer: {
          controller: LeadPopupCtrl,
          controllerAs: 'vm',
          template: leadPopupTemplate,
        },
      },
      onEnter() {
        $('.mdl-js-layout').addClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': 100 });
      },
      onExit() {
        $('.mdl-js-layout').removeClass('-sidebar_expanded');
        $('.l-sidebar').css({ 'z-index': '' });
      },
    });
}
